<template>
  <v-toolbar  color="white" app fixed dense prominent flat
    style="border-bottom:1px #CDD2E0 solid !important"
    extension-height="25px">
      <v-toolbar-title>
        <span
          v-if="topnav.flag==1"
          :class="topnav.class"
        >
          {{topnav.text}}
        </span>
        <img
          v-if="topnav.flag==2"
          src="../assets/images/logo03.png" alt="">
        <span class="caption hidden-xs-only grey--text">{{user.organizationName}}</span>
      </v-toolbar-title>

     <v-spacer></v-spacer>

    <!-- ナビゲーション  -->
      <div id="nav">
      <v-menu offset-y>
        <v-btn  slot="activator" flat>
          <v-icon class="grey--text hidden-md-and-up">language</v-icon>
          <div class="grey--text hidden-sm-and-down">
            language &nbsp;({{$t("params.label")}}) &nbsp;
            <i class="fa fa-angle-down"></i>
          </div>
        </v-btn>
        <v-list v-for="(label, key) in supportLanguage" v-bind:key = "key">
          <v-list-tile @click="changeLanguage(key)"><span class="body-1">{{label}}</span></v-list-tile>
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <v-btn slot="activator" flat class="grey--text">
          <v-icon>account_circle</v-icon> &nbsp;
          <div class="hidden-xs-only">
            {{ user.username }} &nbsp;
            <role-label :role="user.roles[0]['name']"></role-label>  &nbsp;
            <i class="fa fa-angle-down"></i>
          </div>
        </v-btn>
        <v-list >
          <router-link :to="{ name: 'Profile' }">
            <!-- @clickをつけないとマウスhoverでグレーにならないので -->
            <v-list-tile @click="" >
              <span class="body-1">Profile</span>
            </v-list-tile>
          </router-link>
          <router-link :to="{ name: 'Usage Report' }">
            <v-list-tile @click="" >
              <span class="body-1">Usage Report</span>
            </v-list-tile>
          </router-link>
          <v-list-tile @click="logout">
            <a href="javascript:;" class="body-1">Log Out <i class="fa fa-sign-out"></i></a>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>

    <!--  メニューバー  -->
    <v-toolbar-items slot="extension" class="justify-center" id="nav-menu">
      <v-btn v-for="menu in topMenus" flat :to="menu.to" v-show="menu.show" :key="menu.to">
       <div>
         {{menu.label}}
       </div>
     </v-btn>
    </v-toolbar-items>

  </v-toolbar>
</template>

<script>
import RoleLabel from '@/components/RoleLabel.vue'
import cognito from '@/utils/cognito.js'
import config from '@/config.js'
import utils from '@/utils/utils.js'

export default {
  name: 'Topnav',
  components: {
    RoleLabel
  },
  data () {
    return {
      user: this.$store.getters.user, // ログインユーザ
      ROLE_Root: config.role.Root,                   // Roleの定数
      ROLE_Administrator: config.role.Administrator, // Roleの定数
      ROLE_Manager: config.role.Manager,             // Roleの定数
      ROLE_Staff: config.role.Staff,                  // Roleの定数
      topMenus: [],
      supportLanguage: [],
      topnav: {
        flag: '',
        text: '',
        class: ''
      }
    }
  },
  methods: {
    logout () {
      cognito.logout()
        .then(() => this.$store.dispatch('logout'))
        .then(() => {
          console.log('logout (opt out)')
          this.$router.push('/login')
        }).catch(err => {
          console.log('logout failed')
          console.log(err)
          this.$router.push('/login')
        })
    },
    changeLanguage (lang) {
      this.$store.dispatch('setLanguage', lang)
      this.$i18n.locale = lang
    },
    requiredRoles (roles) {
      return this.$store.getters.userHasThoseRoles(roles)
    },
    currentPage (to) {
      switch (to) {
        default:
          return this.$route.path === to ? 'current_page' : ''
      }
    },
    makeTopMenus () {
      this.topMenus = [
        {
          to: '/',
          show: this.requiredRoles([]),
          label: this.$t('global-menu.dashboard')
        },
        {
          to: '/watersystem_list',
          show: this.requiredRoles([]),
          label: this.$t('global-menu.watersystem')
        },
        {
          to: '/customer_list',
          show: this.requiredRoles([]),
          label: this.$t('global-menu.customer')
        },
        {
          to: '/settings/display',
          show: this.requiredRoles([]),
          label: this.$t('global-menu.setting')
        }
      ]
    },
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      this.topnav = domainConfig.topnav
      this.supportLanguage = domainConfig.supportLanguage
    }
  },
  mounted () {
    console.log(this.$route.fullPath)
    this.makeTopMenus()
    this.getDomainConfig()
  }
}
</script>
<style>

#nav-menu .btn--active >.btn__content {
  color: #FFF;
}
#nav-menu .btn--active >.btn__content div{
  height: 100%;
  color:#0658CA;
  border-bottom: #0658CA 2px solid !important;
  padding-top: 3px; /* TODO:直書き*/
}
#nav-menu a > div {
  cursor: pointer !important;
}

.nav-org-name {
  vertical-align: bottom;
}


@media (max-width:599px) {
  #nav .menu__activator {
    width: 50px;
  }
}



</style>



// WEBPACK FOOTER //
// Topnav.vue?e484f7d4